<template>
  <div v-if="role === 3">
    <!-- 签到 -->
    <SignIn ref="signRef" :visible="isShowSign" :limit="localLimitTime" @start="onStart" @close="close" />
    <!-- 签到中 -->
    <SignIng :visible.sync="signIngVisible" :duration="duration" :count="signInCount" :title="title" @end="end" />
    <!-- 结束签到 -->
    <SignInd :visible.sync="signIndVisible" :count="signInCount" :total="total" :limit="localLimitTime" @reStart="reStart" />
  </div>
  <div v-else>
    <!-- 嘉宾签到 -->
    <SignIngGuest :visible.sync="guestSignIngVisible" :duration="duration" :count="signInCount" :title="title" @signInSuccess="signInSuccess" />
  </div>
</template>

<script>
import Role from "@/mixins/role";
// 签到
import SignIn from "@/components/toolList/signIn/signIn";
// 签到中
import SignIng from "@/components/toolList/signIn/signIng";
// 嘉宾签到
import SignIngGuest from "@/components/toolList/signIn/signIngGuest";
// 结束签到
import SignInd from "@/components/toolList/signIn/signInd";
// API
import { rollcall } from "@/api/liveRequest/rollcalls";
// Scoket message
import { pushRoomMessageFunc } from "@/utils/socketMessageDispose";
import { mapGetters } from "vuex";
export default {
  name: "SignInMain",
  mixins: [Role],
  components: {
    SignIn,
    SignIng,
    SignInd,
    SignIngGuest,
  },
  data() {
    return {
      // 签到弹窗
      signInVisible: false,
      // 签到中弹窗
      signIngVisible: false,
      // 签到结束弹窗
      signIndVisible: false,
      // 签到时长
      duration: 0,
      // 当前已签到人数
      signInCount: 0,
      // 签到总人数
      total: 0,
      // 签到提示语
      title: "",
      // 签到信息
      sign: undefined,
      // 签到倒计时
      timer: undefined,
      // 两次签到发起最小间隔：60秒
      localLimitTime: 0,
      // 限制间隔计时
      limitTimer: undefined,
      // range 签到范围 1是观众,2个嘉宾,3是观众+嘉宾
      range: 2,
    };
  },
  computed: {
    ...mapGetters(["isShowSign"]),
    guestSignIngVisible() {
      // 判断嘉宾是否需要显示签到
      return this.signIngVisible && (this.range === 2 || this.range === 3);
    },
  },
  created() {
    pushRoomMessageFunc(({ cmd, requestData }) => {
      const fn = this[`message_${cmd}`];
      typeof fn === "function" && fn(requestData);
    });
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    message_7107(body) {
      switch (body.event) {
        case "rollcall/state":
          this.rollcall(body);
          break;
      }
    },
    message_7127(body) {
      switch (body.event) {
        case "rollcall/statistics":
          this.signInCount = body.signInCount;
          break;
        case "rollcall/state":
          this.rollcall(body);
          break;
        case "TO_BE_MAIN_CONTROL":
          this.signIngVisible = false;
          break;
      }
    },
    // 签到
    rollcall(body) {
      this.sign = body;
      switch (body.state) {
        // 开始签到
        case 0:
          this.signIngVisible = true;
          this.signIndVisible = false;
          this.signInCount = 0;
          this.total = 0;
          this.localLimitTime = 60;
          this.duration = body.duration;
          this.title = body.title;
          this.range = body.range;
          this.clearLimit();
          this.start();
          break;
        // 结束签到
        case 1:
          this.signIngVisible = false;
          this.total = body.userCount;
          this.signInCount = body.signInCount;
          this.range = body.range;
          this.updateLimitTime();
          this.clear();
          this.$store.commit("SET_SHOW_SIGN", false);
          if (this.role === 3) {
            this.signIndVisible = true;
          }
          break;
      }
    },
    // 重新签到
    reStart() {
      this.signIndVisible = false;
      this.$store.commit("SET_SHOW_SIGN", true);
    },
    // 开始计时
    start() {
      this.timer = setInterval(() => {
        if (this.duration <= 0) {
          this.clear();
        } else {
          this.duration = this.duration - 1;
        }
      }, 1000);
    },
    onStart() {
      this.signIngVisible = true;
    },
    // 结束
    async end() {
      this.clear();
      let params = {
        confId: this.sign.confId,
        id: this.sign.id,
        state: 1,
      };
      await rollcall.state(params);
    },
    signInSuccess() {
      this.signIngVisible = false;
    },
    // 清空计时器
    clear() {
      clearInterval(this.timer);
      this.timer = null;
    },
    close() {
      this.$store.commit("SET_SHOW_SIGN", false);
    },
    updateLimitTime() {
      this.limitTimer = setInterval(() => {
        this.localLimitTime -= 1;
        if (this.localLimitTime <= 0) {
          this.clearLimit();
        }
      }, 1000);
    },
    clearLimit() {
      clearInterval(this.limitTimer);
      this.limitTimer = null;
    },
  },
};
</script>
